import type { ContentNode, DocumentState } from '../document-types';
import type { NodeHandler, RenderContext } from './types';

export class HeadingHandler implements NodeHandler {
  readonly type = 'heading';

  render(
    node: ContentNode | DocumentState,
    _parent: ContentNode | DocumentState | null,
    childContent: string,
    _ctx: RenderContext
  ): string {
    const level = (node as ContentNode).attrs?.['level'] ?? 1;
    return '#'.repeat(level) + ' ' + childContent + '\n\n';
  }
}
